import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-progress-circle WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, ProgressCircleWebElement.ts.
 */
export class ProgressCircleWebElementBase extends OjWebElement {
  /**
   * Gets the value of <code>max</code> property.
   * The maximum allowed value.
   * @return The value of <code>max</code> property.
   *
   */
  public getMax(): Promise<number> {
    return this.getProperty<number>('max');
  }

  /**
   * Gets the value of <code>value</code> property.
   * The value of the Progress Circle.
   * @return The value of <code>value</code> property.
   *
   */
  public getValue(): Promise<number> {
    return this.getProperty<number>('value');
  }

  /**
   * Gets the value of <code>size</code> property.
   * Specifies the size of the progress circle.
   * @return The value of <code>size</code> property.
   *
   */
  public getSizeProperty(): Promise<string> {
    return this.getProperty<string>('size');
  }
}
